import React from "react";
import { inr } from "@/lib/api";

export const offerLeft = (until) => {
  if (!until) return null;
  const t = new Date();
  const today = Date.UTC(t.getFullYear(), t.getMonth(), t.getDate());
  const [y, m, d] = until.split("-").map(Number);
  return Math.round((Date.UTC(y, m - 1, d) - today) / 86400000);
};

export const offerText = (price, mrp, until) => {
  const d = offerLeft(until);
  if (!(Number(mrp) > Number(price) && Number(price) > 0) || (d !== null && d < 0)) return "";
  return `${inr(mrp - price)} OFF${d === null ? "" : d === 0 ? " · last day" : ` · only ${d} day${d === 1 ? "" : "s"} left`}`;
};

// Original price crossed out + offer price + "₹X OFF · only N days left" badge.
export const PriceTag = ({ price, mrp, until, big = false, testid }) => {
  const txt = offerText(price, mrp, until);
  return (
    <span className="inline-flex items-baseline flex-wrap gap-x-2 gap-y-1" data-testid={testid}>
      {txt && <span className={`line-through text-white/50 ${big ? "text-sm" : "text-xs"}`}>{inr(mrp)}</span>}
      <span className={`text-gold font-mono font-semibold ${big ? "text-2xl" : "text-base"}`}>{inr(price)}</span>
      {txt && <span className="text-[10px] font-bold rounded-full bg-red-500/85 text-white px-2 py-0.5 animate-pulse" data-testid={testid ? `${testid}-offer` : undefined}>{txt}</span>}
    </span>
  );
};
